import React from 'react';

import ScrollMenu from 'react-horizontal-scrolling-menu';

import { Button, Tooltip } from 'antd';
import { PlusOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ShareIcon } from '../academy.svg';
// eslint-disable-next-line import/no-cycle
import { academyConst } from '../academy';

const ListTabs = (props) => {
  const {
    openModalForCreateNewList,
    activeListKey,
    lists = [],
    modalType,
    edit,
    changeState,
  } = props;

  const handleOnClick = (item) =>
    changeState({
      activeListKey: item.id,
      activeList: item,
    });

  const handleShare = () =>
    changeState({
      shareModalShow: true,
      shareType: academyConst.LIST,
    });

  const Arrow = ({ text, className }) => {
    return <div className={className}>{text}</div>;
  };
  const ArrowLeft = Arrow({
    text: <LeftOutlined style={{ fontSize: 30 }} />,
    className: 'arrow-prev',
  });
  const ArrowRight = Arrow({
    text: <RightOutlined style={{ fontSize: 30 }} />,
    className: 'arrow-next',
  });

  const getTooltip = (item) => {
    const { count } = item;

    return (
      <div className="tooltip_count">
        <div>
          <span>
            <FormattedMessage
              id="user finished the training course."
              defaultMessage="{count} user finished the training course."
              values={{ count }}
            />
          </span>
        </div>
        <div className="see">
          <Link to="/members?scope=star">
            <FormattedMessage
              id="See all who completed the training"
              defaultMessage="See all who completed the training"
            />
          </Link>
        </div>
      </div>
    );
  };
  const Menu = (list) =>
    list.map((item) => {
      return (
        <Tooltip placement="top" title={getTooltip(item)} mouseEnterDelay={0.5}>
          <div className="item_wrapper" key={item.id}>
            <div
              className={item.id === activeListKey ? 'item active' : 'item'}
              key={item.id}
              onClick={() => handleOnClick(item)}
              aria-hidden
            >
              {item.title}
            </div>
            <ShareIcon
              width="18px"
              height="18px"
              className="share_icon"
              style={{ marginLeft: 5 }}
              onClick={() => handleShare()}
            />
            <div
              className="share_tab_div"
              onClick={() => handleShare()}
              aria-hidden
            />
          </div>
        </Tooltip>
      );
    });

  const UploadButton = () => (
    <div className="add_layout">
      <Button
        type="primary"
        size="small"
        className="add"
        onClick={() => openModalForCreateNewList(modalType)}
      >
        <PlusOutlined style={{ fontSize: 14 }} />
      </Button>
    </div>
  );

  return (
    <div className="panels">
      <div className={edit ? 'list edit' : 'list'}>
        <ScrollMenu
          data={Menu(lists)}
          arrowLeft={ArrowLeft}
          arrowRight={ArrowRight}
          hideArrows
          hideSingleArrow
          alignCenter={false}
          menuWidth="100%"
        />
      </div>
      {edit ? <UploadButton /> : null}
    </div>
  );
};

export default ListTabs;
